import L from "leaflet";
import {positionMarker} from "./mapUtils";
import {shape} from "./shapes";

export const initMinimalMiniMap = (mapElement, outlineCity, locationInfos, layersPosition, initialZoom, initialBaseLayer) => {
    //layers
    const grayScaleLayer = L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
        subdomains: 'abcd',
        maxZoom: 20
    });
    const arcgisLayer = L.tileLayer(
        'https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}',
        {
            attribution: '&copy; ESRI contributors',
        }
    );
    const satelliteLayer = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
        attribution: '&copy; Esri'
    });
    const tileLayers = {
        [`<img id="gray-scale-layer" src="/img/layers/gray-scale-layer.png" alt="Carte en niveaux de gris"><p>Niveaux de gris</p>`] : grayScaleLayer,
        [`<img id="arcgis-layer" src="/img/layers/arcgis-layer.png" alt="Carte en vue plan"><p>Plan</p>`]: arcgisLayer,
        [`<img id="satellite-layer" src="/img/layers/satellite-layer.png" alt="Carte en vue satellite"><p>Satellite</p>`]: satelliteLayer
    };
    
    const layersControl = L.control.layers(tileLayers, null, {collapsed: false, position: layersPosition ? layersPosition : 'topright'}).addTo(mapElement);
    L.DomUtil.addClass(layersControl.getContainer(), 'layers-control');
    switch (initialBaseLayer) {
        case 'plan':
            arcgisLayer.addTo(mapElement);
            break;
        case 'satellite':
            satelliteLayer.addTo(mapElement);
            break;
        default:
            grayScaleLayer.addTo(mapElement);
            break;
    }
    mapElement.on('baselayerchange', (e) => {
        if (e.name.startsWith('<img id=')) {
            layersControl.getContainer().querySelectorAll(`img[id$=layer]`).forEach(img => img.parentElement.parentElement.parentElement.classList.remove('selected'));
            let selectParent = (value) => layersControl.getContainer().querySelector(`img[id^=${value}]`).parentElement.parentElement.parentElement.classList.add('selected');
            (e.name).indexOf('gray-scale') !== -1 && selectParent('gray-scale');
            (e.name).indexOf('arcgis') !== -1 && selectParent('arcgis');
            (e.name).indexOf('satellite') !== -1 && selectParent('satellite');
        }
    });
    layersControl.getContainer().addEventListener('click', (e) => {
        e.stopPropagation();
        if (e.target.tagName === 'DIV' || e.target.tagName === 'INPUT') {
            L.DomUtil.hasClass(layersControl.getContainer(), 'active') ? L.DomUtil.removeClass(layersControl.getContainer(), 'active') : L.DomUtil.addClass(layersControl.getContainer(), 'active');
        }
    });
    document.addEventListener('click', () => L.DomUtil.hasClass(layersControl.getContainer(), 'active') && L.DomUtil.removeClass(layersControl.getContainer(), 'active'));     

    //zoom
    L.control.zoom({position: "bottomright"}).addTo(mapElement);

    //city outlines
    outlineCity && outlineCity.addTo(mapElement);

    //marker if address & fitBounds
    let bounds = null;
    if(locationInfos.address){
        positionMarker(locationInfos.address, mapElement);
        bounds = L.latLngBounds([locationInfos.address.lat + 0.01, locationInfos.address.lon + 0.01], [locationInfos.address.lat - 0.01, locationInfos.address.lon - 0.01]);
    } else {
        bounds = outlineCity.getBounds();
    }
    if (initialZoom) {
        mapElement.setZoom(initialZoom);
    } else {
        mapElement.fitBounds(bounds);
    }

    //limit bounds
    if (outlineCity) {
        //limit bounds
        mapElement.setMaxBounds(outlineCity.getBounds().pad(1.0));
    } else {
        mapElement.setMaxBounds(mapElement.getBounds().pad(1.0));
    }
}

// create generic map
export const createMiniMap = (id, minZoom=11) => {
    return L.map(`${id}-map`, {
        zoomControl: false,
        zoomSnap: 0.25,
        minZoom,
        maxBoundsViscosity: 1.0,
        dragging: !L.Browser.mobile,
        tap: !L.Browser.mobile
    });
}

// create legend layer group
export const legendGroupMiniMap = (selectedItem, legendList) => {
    let div = L.DomUtil.create('div', 'example');
    div.id = `${selectedItem.id}-legend`;
    div.innerHTML = `
        <div class="collapse collapse-wrapper show" id="collapse-${selectedItem.id}">
            ${(selectedItem.details) ? `<p>${selectedItem.details}</p>` : ''}
            ${legendList.map(l =>
        `<div class="d-flex align-items-start mt-1">
                    <span style="height:18px;width:18px">
                        <span class="h-100">
                            ${shape(l.shape, l.fillColor||l.color, l.strokeColor||l.color, l.strokeWidth, l.fillOpacity)}
                        </span>
                    </span>
                    <p class="my-0 px-2 col-11">${l.label}</p>
                </div>`
    ).join('')}
        </div>`
    return div;
};

